<template>
  <!-- 帮助中心 -->
  <div class="helps">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['资讯管理',$route.meta.title]"></crumbs-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="编号"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="name"
        label="分类名称"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="level"
        label="级别"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button type="primary" style="padding:2px 3px;" plain
            @click="viewDoc(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>
export default {
  name: 'helps',
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"编号",
      //   name:"分类名称",
      //   level:"级别",
      //   sort:"排序"
      // }
      tableData:[],
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
    }
  },
  mounted(){
    this.getTableData()
  },
  methods:{
    updata(){
      this.getTableData()
    },
    /**获取数据 */
    getTableData(){
      let data = {
        type: "GetGoodsCategory_help",
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      }
      let proc = "Proc_Admin_Category" // 存储过程名
      let type = "ReturnList"
      this.$requestSys({
        method: 'post',
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then(res => {
        this.tableData = []
        if(res.flag == 0){
          this.tableData = res.data.map(item => ({
            id: item.id,
            name: item.title,
            level: item.class_layer,
            sort: item.sort_id,
          }))
          this.allPage = res.recordCount
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData()
    },

    /**查看分类下文档 */
    viewDoc(row){
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({id: row.id}))
      }
      this.$router.push({
        path: "viewDoc",
        query:{
          prams: prams
        }
      })
      prams = null
    },
  }
}
</script>

<style scoped>
.helps{
  width: 100%;
  height: 100%;
}
</style>
